import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import axiosInstance from '../utils/axiosInstance';
import Session from "../utils/sessionStorage";
import ConsentCheckModal from '../components/Home/ConcentCheckModal';
import Button from '../components/form/Button';
import ErrorModal from '../components/ErrorModal';
import nodata from "../assets/images/nodata.png";

const RegCustomers = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMNP, setIsMNP] = useState(false);
  const [errorModal, setErrorModal] = useState({ open: false, message: "" });
  const [pagination, setPagination] = useState({
    current_page: 1,
    next_page_url: null,
    prev_page_url: null,
    total: 0,
    per_page: 0
  });
  const token = Session.get("token");

  async function getDataPackage(url = null) {
    setLoading(true);
    try {
      const endpoint = url || "/api/v1/registered-customer";
      const response = await axiosInstance.get(endpoint,
        {
          params: {
            is_mnp: isMNP
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }

      );
      if (response.status === 200) {
        const data_packages = response?.data?.registered_customers;
        setCustomers(data_packages);
        setPagination(response.data?.meta);
        console.log(" data ", response?.data?.registered_customers);
      }
    } catch (error) {
      console.log("errrorrr", error?.response?.data?.message)
      setErrorModal({ open: true, message: error?.response?.data?.message || "Failed to load registered customers" });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getDataPackage();
  }, [isMNP]);
  console.log("final data to map : ", customers)
  if (loading) {
    return <ConsentCheckModal />
  }
  if (customers?.length === 0) {
    return (
      <>
        <Header />
        <div className="flex flex-col justify-center  bg-white mt-[33px] h-44 rounded-lg mb-3">
          <div className="mx-auto">
            <img src={nodata} alt="no data" className="w-full h-full" />
          </div>
          <p className="font-poppins text-base font-medium text-accent-silver-900 text-center">
            No Data Found
          </p>
        </div>
      </>
    )
  }
  return (
    <div>
      <div className="bg-accent-grey-50 h-screen lg:w-[450px] w-full mx-auto flex flex-col">
        <Header />

        <div className="space-y-2.5 pt-6 mx-4">
          {/* <h1 className="text-2xl font-bold text-center">No Package Data</h1> */}



          {customers?.map((data, index) => {
            return (
              <div
                key={index}
                className=" px-4 py-6 flex flex-col gap-3 border-[2px] border-white bg-primary/5  h-auto rounded-[24px]"
              >
                <h3 className="text-primary font-semibold text-[17px]">
                  {data?.full_name
                  }

                </h3>
                <div className="border-t-[1px] border-[#1111111A]"></div>
                <div className="space-y-1.5">
                  <div className="flex items-center gap-3 gap-x-6">
                    <div>
                      <p className="text-[13px] text-gray">MSISDN</p>
                      <h3 className="text-[13px] font-semibold">
                        {data?.msisdn}
                      </h3>
                    </div>
                    <div>

                      <p className="text-[13px] text-gray">
                        ICCID
                      </p>
                      <h3 className="text-[13px] font-semibold">

                        {data?.iccid ? data?.iccid : "N/A"}
                      </h3>

                    </div>
                  </div>
                </div>

                <div className="justify-between items-center">
                  <p className="text-[13px] text-gray">Registered at:</p>
                  <span className="text-[13px] font-semibold">
                    {data?.registered_at}
                  </span>

                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-auto bg-white p-4">
          <div className="flex justify-between items-center">
            <Button eventAction={() => getDataPackage(pagination.prev_page_url)}
              disable={!pagination.prev_page_url}
              classes={`${!pagination.prev_page_url ? "bg-primary" : ""} text-white py-3 gap-1`}
              size={"md"}>
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
              </svg>
              Prev
            </Button>
            <span className="text-sm font-medium">Page {pagination.current_page} of {Math.ceil(pagination.total / pagination.per_page)}</span>
            <Button
              eventAction={() => getDataPackage(pagination.next_page_url)}
              disable={!pagination.next_page_url} size={"md"}
              classes={`${!pagination.next_page_url ? "bg-primary" : ""} text-white py-3 gap-1`}>
              Next
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
              </svg>
            </Button>
          </div>
        </div>
      </div>

      {/* Error Modal */}
      {errorModal.open && (
        <ErrorModal
          message={errorModal.message}
          close={() => setErrorModal({ open: false, message: "" })}
        />
      )}
    </div>
  )
}

export default RegCustomers
